<template>
  <a class="btnLineColor" @click="clearParams">清空</a>
</template>
<script>

  import {PAGINATION} from "../../../service/businessConsts";

  export default {
    name: 'my-button-empty',
    props: {
      paramsObj:Object,
      fn: Function
    },
    data() {
      return {
        tempParams: this.paramsObj
      }
    },
    created(){
      // console.log(this.tempParams)
    },
    methods: {
      // 清空参数
      clearParams() {
        // for(var key in this.tempParams){
        //   if(key != 'pageNum' && key != 'pageSize'){
        //     this.tempParams[key] = '';
        //   }
        // };

        for(var key in this.tempParams){
          if(key === 'pageNum'){
            this.tempParams[key] = 1

          } else if(key === 'pageSize'){
            this.tempParams[key] = PAGINATION.pageSize
          }
          else {
            this.tempParams[key] = '';
          }
        }

        this.$emit('initQueryDate');   // 恢复默认时间
        
        //清空商户名称
        this.$emit('cooperatorEmpty', this.tempParams);

        this.fn()
      }
    }

  };
</script>


<!--Author: Han Jianxin-->
<!--<template>-->
    <!--<a class="btnLineColor" @click="emptyClickBtn">清空</a>-->
<!--</template>-->
<!--<script>-->
  <!--export default {-->
    <!--name: 'my-button-empty',-->
    <!--props:{-->
        <!--data:{-->
            <!--type:Object,-->
            <!--default:{},-->
        <!--}-->
    <!--},-->
    <!--data(){-->
        <!--return{-->
        <!--}-->
    <!--},-->
    <!--methods:{-->
        <!--emptyClickBtn(){-->
            <!--if(this.mod_cooperatorIdList){-->
                <!--this.mod_cooperatorIdList="";-->
                <!--this.mixin_parmesCooperatorIdList=this.mixin_parmesSelectDistributeChannel.map((item, index) => {-->
                        <!--return item.cooperatorId-->
                 <!--})-->
            <!--}else{-->
                <!--this.mixin_parmesCooperatorIdList=this.mixin_parmesSelectDistributeChannel.map((item, index) => {-->
                     <!--return item.cooperatorId-->
                <!--})-->
            <!--}-->
            <!--if(this.mod_batchState){-->
                <!--this.mod_batchState="";-->
            <!--}-->
            <!--this.mod_cooperatorIdList="";-->
            <!--for (let prop in this.data) {-->
                <!--if(Array.isArray(this.data[prop])){-->
                     <!--this.data[prop]=[];-->
                    <!--continue;-->
                <!--}-->
                <!--if (prop !== '') {-->
                    <!--this.data[prop] = '';-->
                <!--}-->
            <!--}-->
            <!--this.loadCreateDatePtr()-->
            <!--if(this.xhrQueryCreateBtnHandler){-->
                <!--this.xhrQueryCreateBtnHandler();-->
            <!--}-->

            <!--this.$emit('update:data', this.data);-->
        <!--}-->
    <!--}-->

  <!--};-->
<!--</script>-->



// WEBPACK FOOTER //
// src/components/my-button-empty/src/main.vue